import { useState, useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useCreateOrder from './useCreateOrder';
import { useGiftCardState } from '@root/state';
import Modal from '@root/components/modal';
import { useTranslation } from 'react-i18next';
import usePayMethod from '../usePayMethod';

const useSelectDevices = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const payMethodState = usePayMethod();
  const { paying, onCreateOrder } = useCreateOrder();
  const { packageId } = useParams();
  const selectedPackage = useGiftCardState((state) => state.selectedPackage);
  const [selected, setSelected] = useState<string[]>([]);
  const { payMethod } = payMethodState;

  const onSelected = useCallback((vs: any[]) => {
    setSelected(vs);
  }, []);

  const onClickPay = useCallback(() => {
    if (!selectedPackage) {
      navigate(-1);
      return;
    }

    if (!selected.length) {
      // 没选的话通知一下 你没选哦 确定后继续买
      Modal.confirm({
        footerColumn: true,
        content: t('plan_detail_unselect_tips'),
        confirm: t('unselected_continue'),
        cancel: t('cancel'),
        onConfirm: () => {
          onCreateOrder({ curPackage: selectedPackage, payMode: payMethod });
        },
      });
      return;
    }

    onCreateOrder({
      curPackage: selectedPackage,
      deviceIds: selected,
      payMode: payMethod,
    });
  }, [selectedPackage, selected, onCreateOrder, payMethod, navigate, t]);

  useEffect(() => {
    if (selectedPackage?.goodsId !== packageId) {
      navigate(-1);
    }
  }, [navigate, packageId, selectedPackage]);

  useEffect(() => {
    return () => {
      Modal.close();
    };
  }, []);

  return {
    state: {
      selected,
      payMark: selectedPackage?.payMark,
      maxDevNum: selectedPackage?.maxDevNum,
      paying,
      payMethodState,
    },
    action: {
      onSelected,
      onClickPay,
    },
  };
};

export default useSelectDevices;
